import { useEffect, useState } from 'react';
import LogoMark from '../components/LogoMark';
import { apiFetch } from '../config/api';
import styles from './Login.module.css';

export default function ResetPassword({ onBack, initialCode = '' }) {
  const codeFromUrl = (initialCode || '').trim().toUpperCase();
  const hasCodeFromUrl = Boolean(codeFromUrl);
  const [code, setCode] = useState(codeFromUrl);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCode(codeFromUrl);
  }, [codeFromUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!code.trim()) { setError('Please enter your reset code.'); return; }
    if (newPassword.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match.'); return; }

    setLoading(true);
    try {
      await apiFetch('/password-resets/reset', {
        method: 'POST',
        body: JSON.stringify({ code: code.trim().toUpperCase(), new_password: newPassword }),
      });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={`glass-card ${styles.card}`}>
        <div className={styles.logoRow}>
          <LogoMark size={28} />
          <span className={styles.logoText}>car-pool</span>
        </div>

        {done ? (
          <>
            <h1 className={styles.heading}>Password Set!</h1>
            <p className={styles.sub}>Your password has been updated. You can now log in.</p>
            <button className="btn-primary" onClick={onBack} style={{ width: '100%' }}>
              Back to Login
            </button>
          </>
        ) : (
          <>
            <h1 className={styles.heading}>Reset Password</h1>
            <p className={styles.sub}>You're almost done. Choose a new password for your account.</p>

            {error && <div className={styles.error}>{error}</div>}

            <form onSubmit={handleSubmit} className={styles.form}>
              {hasCodeFromUrl ? (
                <details className={styles.codeDetails}>
                  <summary>Reset code loaded from link</summary>
                  <div className={styles.field}>
                    <label className={styles.label}>Reset Code</label>
                    <input
                      className={`glass-input ${styles.input}`}
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      placeholder="e.g. K7HN3P"
                      maxLength={6}
                      style={{ textTransform: 'uppercase', letterSpacing: 3, fontWeight: 700 }}
                      required
                    />
                  </div>
                </details>
              ) : (
                <div className={styles.field}>
                  <label className={styles.label}>Reset Code</label>
                  <input
                    className={`glass-input ${styles.input}`}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="e.g. K7HN3P"
                    maxLength={6}
                    style={{ textTransform: 'uppercase', letterSpacing: 3, fontWeight: 700 }}
                    required
                    autoFocus
                  />
                </div>
              )}
              <div className={styles.field}>
                <label className={styles.label}>New Password</label>
                <input
                  type="password"
                  className={`glass-input ${styles.input}`}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  autoFocus={hasCodeFromUrl}
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Confirm Password</label>
                <input
                  type="password"
                  className={`glass-input ${styles.input}`}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Resetting password…' : 'Reset Password'}
              </button>
            </form>

            <p className={styles.forgot}>
              <button
                onClick={onBack}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#fff', fontWeight: 700, textDecoration: 'underline', fontSize: 'inherit', padding: 0 }}
              >
                Back to Login
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
